import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { IconAIhelp } from '../icon';
import { Link } from '../link';
import { Markdown } from '../markdown';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
export const AIHelp = (props) => {
    return (_jsx(Tooltip, { mode: "light", title: _jsxs(FlexBox, { stack: true, gap: 1, padding: 2, children: [_jsxs(FlexBox, { vAlign: "center", gap: 0.5, children: [_jsx(IconAIhelp, { color: "primary", width: 16, height: 16 }), _jsx(Typography, { variant: "bodyEmphasis", children: props.title })] }), _jsx(Typography, { component: "span", children: _jsx(Markdown, { children: props.children }) })] }), children: props.label }));
};
export const AIHelpTextLink = React.forwardRef((props, ref) => {
    return (_jsxs(Link, { ref: ref, color: "primary.main", ...props, href: "#", sx: {
            display: 'inline-flex',
            gap: 0.5,
            lineHeight: 1.35,
            ...props.sx
        }, onClick: (e) => e.preventDefault(), children: [_jsx(IconAIhelp, { width: 14, height: 14, color: "primary" }), _jsx("span", { children: props.children })] }));
});
